//スマホのドロワーメニュー ------------------------
$(function () {
  var wrp = "html",
    btnOpen = ".drawerbtn_2",
    btnClose = ".slingbelt_parts_spmenu_drawer_closebtn",
    sld = ".slingbelt_parts_spmenu_drawer",
    current_scrollY;

  function func_close() {
    $(wrp).attr({ style: "" });
    $("html, body").prop({ scrollTop: current_scrollY });
    $(btnClose).toggleClass("cl_active");
    $(sld).slideUp();
  }

  $(btnOpen).on("click", function (e) {
    if ($(sld).css("display") == "none") {
      current_scrollY = $(window).scrollTop();
      $(wrp).css({
        position: "fixed",
        width: "100%",
        top: -1 * current_scrollY,
      });
      $(btnClose).toggleClass("cl_active");
      $(sld).slideDown();
    } else if ($(sld).css("display") == "block") {
      func_close();
    }
  });

  $(btnClose).on("click", function () {
    if ($(sld).css("display") == "block") {
      func_close();
    }
  });

  $(document).on("click", function (e) {
    if ($(sld).css("display") == "block") {
      if (!$(e.target).closest(sld).length && !$(e.target).closest(btnOpen).length) {
        $(wrp).attr({ style: "" });
        $("html, body").prop({ scrollTop: current_scrollY });
        $(sld).slideUp();
        $(ovrly).fadeOut();
      }
    }
  });
});

//スマホのアコーディオンメニュー ------------------------
const menuButton2 = document.querySelectorAll(".slingbelt_common_sp_menu_accordion_wrap button");
menuButton2.forEach((e) => {
  e.addEventListener("click", function () {
    const nextnode = e.nextElementSibling;
    e.classList.toggle("open");
    nextnode.classList.toggle("open");
    const openflg = nextnode.classList.contains("open");

    const menu_count = parseFloat(e.dataset.count);
    const hight = menu_count * 48;
    openflg ? (nextnode.style.height = `${hight}px`) : (nextnode.style.height = `0px`);
  });
});

//トップページのSlickの設定
$(function () {
  $(".slingbelt_parts_index_slide_selectcolor_wrap").slick({
    centerMode: true,
    centerPadding: "0%",
    dots: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {},
      },
      {
        breakpoint: 769,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
        },
      },
    ],
  });
});

//最近チェックしたアイテムの処理

//クッキーを削除して履歴をリセットする処理
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

$(".js_removecheckd").click(function () {
  setCookie("shopify_recently_viewed", "", 0);
  location.reload();
});

//クッキーを取得して空なら、最近チェックした項目を消す処理
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var val_checkdproduct = getCookie("shopify_recently_viewed");

if (val_checkdproduct == "" || val_checkdproduct == null) {
  $(".cl_val_checkdproduct").remove();
}

//確認モーダルを最前面に表示できるように、footerのあとに挿入する。
$(".slingbelt_parts_confirm_box").insertAfter(".shopify-section-group-footer-group");

//商品リスト表示の際、サイドバーに対象アイテムの件数を表示する
$(".slingbelt_parts_addsidebar_itemcount").insertBefore(".slingbelt_parts_sidebar .sidemenu_topbnrs");
$(".slingbelt_parts_addsidebar_itemcount").addClass("js_addfix");

$(".p-region-id").change(function () {
  let temp_city = $(this).children("option:selected").text();
  //alert(temp_city);
  $(".p-region").val(temp_city);

  province_seikei();
});

function province_seikei() {
  let tmp_cityname = $(".p-region").val();

  switch (tmp_cityname) {
    case "愛知県":
      tmp_cityname = "Aichi";
      break;
    case "秋田県":
      tmp_cityname = "Akita";
      break;
    case "青森県":
      tmp_cityname = "Aomori";
      break;
    case "千葉県":
      tmp_cityname = "Chiba";
      break;
    case "愛媛県":
      tmp_cityname = "Ehime";
      break;
    case "福井県":
      tmp_cityname = "Fkui";
      break;
    case "福岡県":
      tmp_cityname = "Fukuoka";
      break;
    case "福島県":
      tmp_cityname = "Fukushima";
      break;
    case "岐阜県":
      tmp_cityname = "Gifu";
      break;
    case "群馬県":
      tmp_cityname = "Gunma";
      break;
    case "広島県":
      tmp_cityname = "Hiroshima";
      break;
    case "北海道":
      tmp_cityname = "Hokkaidō";
      break;
    case "兵庫県":
      tmp_cityname = "Hyōgo";
      break;
    case "茨城県":
      tmp_cityname = "Ibaraki";
      break;
    case "石川県":
      tmp_cityname = "";
      break;
    case "hoge":
      tmp_cityname = "";
      break;
    case "hoge":
      tmp_cityname = "Ishikawa";
      break;
    case "岩手県":
      tmp_cityname = "Iwate";
      break;
    case "香川県":
      tmp_cityname = "Kagawa";
      break;
    case "鹿児島県":
      tmp_cityname = "Kagoshima";
      break;
    case "神奈川県":
      tmp_cityname = "Kanagawa";
      break;
    case "熊本県":
      tmp_cityname = "Kumamoto";
      break;
    case "京都府":
      tmp_cityname = "Kyōto";
      break;
    case "高知県":
      tmp_cityname = "Kōchi";
      break;
    case "三重県":
      tmp_cityname = "Mie";
      break;
    case "宮城県":
      tmp_cityname = "Miyagi";
      break;
    case "宮崎県":
      tmp_cityname = "Miyazaki";
      break;
    case "長野県":
      tmp_cityname = "Nagano";
      break;
    case "長崎県":
      tmp_cityname = "Nagasaki";
      break;
    case "奈良県":
      tmp_cityname = "Nara";
      break;
    case "新潟県":
      tmp_cityname = "Niigata";
      break;
    case "岡山県":
      tmp_cityname = "Okayama";
      break;
    case "沖縄県":
      tmp_cityname = "Okinawa";
      break;
    case "佐賀県":
      tmp_cityname = "Saga";
      break;
    case "埼玉県":
      tmp_cityname = "Saitama";
      break;
    case "滋賀県":
      tmp_cityname = "Shiga";
      break;
    case "島根県":
      tmp_cityname = "Shimane";
      break;
    case "静岡県":
      tmp_cityname = "Shizuoka";
      break;
    case "栃木県":
      tmp_cityname = "Tochigi";
      break;
    case "徳島県":
      tmp_cityname = "Tokushima";
      break;
    case "鳥取県":
      tmp_cityname = "Tottori";
      break;
    case "富山県":
      tmp_cityname = "Toyama";
      break;
    case "東京都":
      tmp_cityname = "Tōkyō";
      break;
    case "和歌山県":
      tmp_cityname = "Wakayama";
      break;
    case "山形県":
      tmp_cityname = "Yamagata";
      break;
    case "山口県":
      tmp_cityname = "Yamaguchi";
      break;
    case "山梨県":
      tmp_cityname = "Yamanashi";
      break;
    case "大分県":
      tmp_cityname = "Ōita";
      break;
    case "大阪府":
      tmp_cityname = "Ōsaka";
      break;
  }

  $(".p-region").val(tmp_cityname);
  //$("#AddressProvinceNew").attr("data-default", tmp_cityname);
  $(".js_province_select").val(tmp_cityname);
}

$(".slingbelt_parts_customer_form input").blur(function () {
  province_seikei();

  //alert($(".p-region").val());
});
